/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const klaytn_chain_about = () => `Kaia (ex. Klaytn), an open-source public blockchain created by South Korean internet giant Kakao, prioritizes the metaverse, gaming, and the creator economy. Tailored for the evolving on-chain landscape, Kaia underscores enterprise-grade reliability through its optimized, Byzantine Fault Tolerant (BFT)-based blockchain. Kaia's mission is to decrease the operational costs of blockchain applications, enhance accessibility for end-users, and streamline technology adoption across industries.`
